import { get_plans, type Plans } from '@/features/pricing';

let cachedPromise: Promise<Plans> | null = null;

/**
 * Returns a shared promise for subscription plans (in-flight or resolved).
 *
 * @returns Promise resolving to the plans payload from {@link get_plans}.
 */
export function loadPlans(): Promise<Plans> {
  if (!cachedPromise) {
    cachedPromise = get_plans().catch((error: unknown) => {
      cachedPromise = null;
      throw error;
    });
  }
  return cachedPromise;
}

/**
 * Starts loading plans if not already in flight (fire-and-forget prefetch).
 */
export function prefetchPlans(): void {
  void loadPlans();
}

/**
 * Clears the shared plans promise. Intended for unit tests only.
 */
export function resetPlansCache(): void {
  cachedPromise = null;
}
